(function () {
  function init(root) {
    root.querySelectorAll('[data-ct-faqhub]').forEach((hub) => {
      if (hub.dataset.ctInit) return;
      hub.dataset.ctInit = 'true';

      const pills = hub.querySelectorAll('[data-ct-faq-pill]');
      const categories = hub.querySelectorAll('[data-ct-faq-category]');
      const searchInput = hub.querySelector('[data-ct-faq-search]');
      const tags = hub.querySelectorAll('[data-ct-faq-tag]');
      const emptyState = hub.querySelector('[data-ct-faq-empty]');

      function setActiveCategory(name) {
        pills.forEach((p) => p.classList.toggle('is-active', p.dataset.ctFaqPill === name));
        categories.forEach((c) => c.classList.toggle('is-active', c.dataset.ctFaqCategory === name));
      }

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          if (searchInput) searchInput.value = '';
          hub.classList.remove('is-searching');
          setActiveCategory(pill.dataset.ctFaqPill);
        });
      });

      function runSearch(query) {
        const q = query.trim().toLowerCase();

        if (!q) {
          hub.classList.remove('is-searching');
          categories.forEach((cat) => {
            cat.querySelectorAll('[data-ct-faq-item]').forEach((item) => item.classList.remove('is-hidden'));
          });
          if (emptyState) emptyState.classList.remove('is-visible');
          return;
        }

        hub.classList.add('is-searching');
        let anyMatch = false;

        categories.forEach((cat) => {
          let catHasMatch = false;
          cat.querySelectorAll('[data-ct-faq-item]').forEach((item) => {
            const text = item.dataset.ctFaqSearch || '';
            const matches = text.indexOf(q) !== -1;
            item.classList.toggle('is-hidden', !matches);
            if (matches) { catHasMatch = true; anyMatch = true; }
          });
          cat.classList.toggle('has-matches', catHasMatch);
        });

        if (emptyState) emptyState.classList.toggle('is-visible', !anyMatch);
      }

      if (searchInput) {
        searchInput.addEventListener('input', (e) => runSearch(e.target.value));
      }

      tags.forEach((tag) => {
        tag.addEventListener('click', () => {
          const text = tag.dataset.ctFaqTag || tag.textContent.trim();
          if (searchInput) {
            searchInput.value = text;
            searchInput.focus();
          }
          runSearch(text);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();